// extracted by mini-css-extract-plugin
export default {"tableContainer":"CategoryTable_tableContainer__jXBEY","scoreDeduction":"CategoryTable_scoreDeduction__LeWt4"};